export default __webpack_public_path__ + "static/media/pending.d0357479.svg";